// /**
//  * leisten.js
//  * Optimized Cart logic using reliable data attributes instead of HTML text scraping.
//  *
//  * CHANGELOG
//  * - Fix: Parkett items (empty data-type) were not recognised as flooring, so the free
//  *   Fußleisten were removed right after being added. Flooring detection is now shared
//  *   (isFlooringType / isFlooringLi) and also accepts items with data-m2-per-package > 0.
//  *   added a condition to fix the trittschalldaemmung products icorrectly being identifying as flooring product 
//  */

// /* ============================================================
//  * 1. CONFIG
//  * ============================================================ */
// const CONFIG = {
//   LEISTEN_VARIANTS: [54219343888652, 54219671994636].map(String),
//   CART_ITEM_SELECTOR: '.mini-cart__navigation > li',
//   ENDPOINTS: { CHANGE: '/cart/change.js', ADD: '/cart/add.js', GET: '/cart.js' },
//   FLOORING_KEYWORDS: ['boden', 'vinyl', 'laminat', 'parkett'],
//   ACCESSORY_KEYWORDS: ['dammung', 'zubehor', 'kleber', 'eliminator', 'dampfbremse', 'folie'],
//   EXCLUDED_TAGS: ['trittschalldämmung', 'trittschalldaemmung'],
//   CHECKOUT_SELECTORS: [
//     '[name="checkout"]',
//     '[href="/checkout"]',
//     'a[href*="/checkout"]',
//     '.cart__checkout-button',
//     '.checkout-button',
//     'button[data-checkout]',
//     '#checkout',
//   ].join(', ')
// };

// const MANUALLY_REMOVED_ITEMS = new Set();
// let isProcessing = false;
// let isLocked = false;

// /* ============================================================
//  * HELPERS: SHARED FLOORING DETECTION
//  * ============================================================ */
// const isFlooringType = (t) => {
//   const s = (t || '').toLowerCase();
//   return CONFIG.FLOORING_KEYWORDS.some(k => s.includes(k));
// };

// const isAccessoryHandle = (h) => {
//   const s = (h || '').toLowerCase();
//   return CONFIG.ACCESSORY_KEYWORDS.some(k => s.includes(k));
// };

// const hasExcludedTag = (li) => {
//   const tags = (li.getAttribute('data-tags') || '').toLowerCase().split('|');
//   return CONFIG.EXCLUDED_TAGS.some(t => tags.includes(t));
// };

// // DOM-based check. Type match OR a positive m2-per-package (covers Parkett with empty data-type).
// const isFlooringLi = (li) => {
//   if (isAccessoryHandle(li.getAttribute('data-handle'))) return false;
//   if (hasExcludedTag(li)) return false;   // tagged Trittschalldämmung → never flooring

//   const type = (li.getAttribute('data-type') || '').toLowerCase();
//   const m2 = parseFloat(li.getAttribute('data-m2-per-package')) || 0;
//   const isCustomLook = li.getAttribute('data-custom-look') === 'true';
//   const isSample = li.getAttribute('data-is-sample') === 'true';
//   return (isFlooringType(type) || m2 > 0) && isCustomLook && !isSample;
// };
// /* ============================================================
//  * HELPER: SECURE GENUINE FLOORING CHECK (ACCURATE TAG MATCHING)
//  * ============================================================ */
// const isGenuineFlooring = (item) => {
//   // 1. Primary Check: DOM Data Attributes
//   const domItem = document.querySelector(`${CONFIG.CART_ITEM_SELECTOR}[data-key="${item.key}"], ${CONFIG.CART_ITEM_SELECTOR}[data-variant-id="${item.variant_id}"]`);

//   if (domItem) {
//     // Explicitly block known accessories that might be wrongly categorized as flooring
//     if (isAccessoryHandle(domItem.getAttribute('data-handle'))) {
//       return false;
//     }

//     return isFlooringLi(domItem);
//   }

//   // 2. Strict Fallback Check
//   const type = (item.product_type || '').toLowerCase();
//   const title = (item.title || '').toLowerCase();

//   if (isAccessoryHandle(item.handle)) {
//     return false;
//   }

//   const matchesFlooring = isFlooringType(type);
//   const isSampleFallback = type.includes('muster') || title.includes('muster');

//   return matchesFlooring && !isSampleFallback;
// };

// /* ============================================================
//  * 2. CART API
//  * ============================================================ */
// const CartAPI = {
//   queue: Promise.resolve(),
//   enqueue(fn) {
//     this.queue = this.queue.then(fn).catch(err => console.error('CartAPI error:', err));
//     return this.queue;
//   },
//   update(key, quantity) {
//     return this.enqueue(() => fetch(CONFIG.ENDPOINTS.CHANGE, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id: key, quantity })
//     }));
//   },
//   add(id, quantity) {
//     return this.enqueue(() => fetch(CONFIG.ENDPOINTS.ADD, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id, quantity })
//     }));
//   },
//   getCart: () => fetch(CONFIG.ENDPOINTS.GET).then(res => res.json())
// };

// /* ============================================================
//  * 3. DOM HELPERS (MODERNIZED PURE MATH DATA LOOPS)
//  * ============================================================ */
// const DOM = {
//   calculateBodenSum: () => {
//     const items = document.querySelectorAll(CONFIG.CART_ITEM_SELECTOR);

//     return Array.from(items).reduce((sum, li) => {
//       if (isFlooringLi(li)) {
//         const m2PerPackage = parseFloat(li.getAttribute('data-m2-per-package')) || 0;
//         const quantity = parseInt(li.getAttribute('data-quantity')) || 0;
//         return sum + (m2PerPackage * quantity);
//       }
//       return sum;
//     }, 0);
//   },
//   hasMainBodenProduct: () => DOM.calculateBodenSum() > 0
// };

// /* ============================================================
//  * 4. CORE LOGIC
//  * ============================================================ */
// window.addLeisten = async function (manualVariantId = null) {
//   if (isProcessing || isLocked) return;
//   isProcessing = true;

//   try {
//     const cart = await CartAPI.getCart();
//     const bodenSum = DOM.calculateBodenSum();
//     const apiHasFlooring = cart.items.some(item => isGenuineFlooring(item));

//     if (apiHasFlooring && bodenSum === 0) {
//       // Sync Guard: API has flooring, but DOM attributes are parsing at 0. Skip run to prevent accidental removal.
//       isProcessing = false;
//       return;
//     }

//     let targetQty = 0;
//     if (apiHasFlooring && bodenSum >= 10) {
//       targetQty = Math.round(bodenSum / 2.4);
//     }

//     const activeInCart = cart.items.filter(item => CONFIG.LEISTEN_VARIANTS.includes(String(item.variant_id)));
//     let updated = false;

//     if (!apiHasFlooring || (bodenSum > 0 && bodenSum < 10)) {
//       for (const item of activeInCart) {
//         await CartAPI.update(item.key, 0);
//         updated = true;
//       }
//     }
//     else if (targetQty > 0) {
//       if (activeInCart.length > 0) {
//         const primaryItem = activeInCart[0];
//         if (primaryItem.quantity !== targetQty) {
//           await CartAPI.update(primaryItem.key, targetQty);
//           updated = true;
//         }
//       } else {
//         const variantToAdd = manualVariantId
//           ? (!MANUALLY_REMOVED_ITEMS.has(String(manualVariantId)) ? manualVariantId : null)
//           : CONFIG.LEISTEN_VARIANTS.find(v => !MANUALLY_REMOVED_ITEMS.has(v));

//         if (variantToAdd) {
//           await CartAPI.add(variantToAdd, targetQty);
//           updated = true;
//         }
//       }
//     }

//     if (updated) {
//       isLocked = true;
//       document.querySelector('cart-items')?.updateAllQuantities?.();
//       setTimeout(() => { isLocked = false; }, 1500);
//     }

//     // --- EVALUATE CHECKOUT FLAG ---
//     let finalCart = cart;
//     if (updated) {
//       finalCart = await CartAPI.getCart();
//     }
//     CheckoutGate.updateButtonState(finalCart);

//   } catch (e) {
//     console.error("Script Error:", e);
//   } finally {
//     isProcessing = false;
//   }
// };

// /* ============================================================
//  * 5. CHECKOUT GATE (WITH FLAG LOGIC)
//  * ============================================================ */
// const CheckoutGate = {
//   updateButtonState(cart) {
//     const cartValue = cart.total_price || 0;
//     const hasFreeProduct = cart.items.some(i => CONFIG.LEISTEN_VARIANTS.includes(String(i.variant_id)));
//     const hasSampleProduct = cart.items.some(i => {
//       const domItem = document.querySelector(`[data-key="${i.key}"], [data-variant-id="${i.variant_id}"]`);
//       if (domItem) return domItem.getAttribute('data-is-sample') === 'true';
//       const type = (i.product_type || '').toLowerCase();
//       const title = (i.title || '').toLowerCase();
//       return type.includes('muster') || title.includes('muster');
//     });

//     let flag = true;

//     // RULE 1: Cart value is 0, contains sample AND free product => Disable
//     if (cartValue === 0 && hasSampleProduct && hasFreeProduct) {
//       flag = false;
//     }

//     // Apply the flag to all checkout buttons
//     const checkoutBtns = document.querySelectorAll(CONFIG.CHECKOUT_SELECTORS);
//     checkoutBtns.forEach(btn => {
//       if (!flag) {
//         btn.disabled = true;
//         btn.style.opacity = '0.5';
//         btn.style.pointerEvents = 'none';
//         btn.title = 'Checkout gesperrt: Ungültige Gratisartikel im Warenkorb.';
//       } else {
//         if (btn._gateActive) return; // Preserve spinner state if currently processing
//         btn.disabled = false;
//         btn.style.opacity = '';
//         btn.style.pointerEvents = '';
//         btn.title = '';
//       }
//     });
//   },

//   waitForIdle(maxMs = 5000) {
//     return new Promise(resolve => {
//       const start = Date.now();
//       const tick = () => {
//         if (!isProcessing && !isLocked) return resolve(true);
//         if (Date.now() - start > maxMs) return resolve(false);
//         setTimeout(tick, 80);
//       };
//       tick();
//     });
//   },

//   async verifyCartSafe() {
//     try {
//       const cart = await CartAPI.getCart();
//       const hasLeisten = cart.items.some(i => CONFIG.LEISTEN_VARIANTS.includes(String(i.variant_id)));
//       const hasFlooring = cart.items.some(i => isGenuineFlooring(i));

//       if (hasLeisten && !hasFlooring) return false;

//       if (hasFlooring && hasLeisten) {
//         const bodenSum = DOM.calculateBodenSum();
//         const domIsVisible = Array.from(document.querySelectorAll(`${CONFIG.CART_ITEM_SELECTOR}[data-custom-look="true"]`))
//           .some(el => el.offsetHeight > 0 || el.offsetWidth > 0);
//         if (domIsVisible && bodenSum > 0 && bodenSum < 10) return false;
//       }

//       return true;
//     } catch {
//       return false;
//     }
//   },

//   showSpinner(btn) {
//     if (!btn || btn._gateActive) return;
//     btn._gateActive = true;
//     btn._origHTML = btn.innerHTML;
//     btn._origDisabled = btn.disabled;
//     btn.disabled = true;
//     btn.innerHTML = 'Warenkorb wird aktualisiert&hellip;';
//     btn.style.opacity = '0.65';
//     btn.style.cursor = 'wait';
//   },

//   hideSpinner(btn) {
//     if (!btn) return;
//     btn._gateActive = false;
//     btn.disabled = btn._origDisabled || false;
//     btn.innerHTML = btn._origHTML || btn.innerHTML;
//     btn.style.opacity = '';
//     btn.style.cursor = '';
//   },

//   showError(msg) {
//     document.getElementById('_leisten-err')?.remove();
//     const el = document.createElement('div');
//     el.id = '_leisten-err';
//     el.setAttribute('role', 'alert');
//     Object.assign(el.style, {
//       position: 'fixed', top: '16px', left: '50%',
//       transform: 'translateX(-50%)', background: '#c0392b',
//       color: '#fff', padding: '12px 22px', borderRadius: '6px',
//       fontSize: '14px', zIndex: '999999',
//       boxShadow: '0 4px 14px rgba(0,0,0,.3)',
//       maxWidth: '88vw', textAlign: 'center', lineHeight: '1.4'
//     });
//     el.textContent = msg;
//     document.body.appendChild(el);
//     setTimeout(() => el.remove(), 4500);
//   },

//   _navigate(btn) {
//     if (btn.tagName === 'A' && btn.href && !btn.href.endsWith('/cart')) {
//       window.location.href = btn.href;
//       return;
//     }
//     const form = btn.closest('form');
//     if (form && form.action && form.action.includes('checkout')) {
//       window.location.href = form.action;
//       return;
//     }
//     window.location.href = '/checkout';
//   },

//   async onCheckoutEvent(e) {
//     const btn = e.target.closest(CONFIG.CHECKOUT_SELECTORS);
//     if (!btn || btn._gateActive || btn.disabled) return;

//     e.preventDefault();
//     e.stopImmediatePropagation();

//     CheckoutGate.showSpinner(btn);

//     void window.addLeisten();

//     const idled = await CheckoutGate.waitForIdle(5000);
//     if (!idled) {
//       CheckoutGate.hideSpinner(btn);
//       CheckoutGate.showError('Warenkorb aktualisiert noch. Bitte versuchen Sie es gleich noch einmal.');
//       return;
//     }

//     const safeNow = await CheckoutGate.verifyCartSafe();
//     CheckoutGate.hideSpinner(btn);

//     if (!safeNow) {
//       CheckoutGate.showError('Ihr Warenkorb wurde korrigiert. Bitte gehen Sie erneut zur Kasse.');
//       return;
//     }

//     CheckoutGate._navigate(btn);
//   },

//   attach() {
//     CheckoutGate._boundClick = (e) => CheckoutGate.onCheckoutEvent(e);
//     CheckoutGate._boundTouch = (e) => CheckoutGate.onCheckoutEvent(e);
//     document.addEventListener('click',      CheckoutGate._boundClick, true);
//     document.addEventListener('touchstart', CheckoutGate._boundTouch, { capture: true, passive: false });
//     document.body.classList.add('cart-gate-ready');
//   }
// };

// /* ============================================================
//  * 6. ENGINE & OBSERVERS
//  * ============================================================ */
// const CartEngine = {
//   debounceTimer: null,
//   init() {
//     CheckoutGate.attach();

//     document.addEventListener('change', (e) => {
//       if (e.target.matches('.quantity__input')) {
//         const item = e.target.closest(CONFIG.CART_ITEM_SELECTOR);
//         const vid = item?.getAttribute('data-variant-id');

//         if (CONFIG.LEISTEN_VARIANTS.includes(String(vid)) && parseInt(e.target.value) === 0) {
//           MANUALLY_REMOVED_ITEMS.add(String(vid));
//         }

//         clearTimeout(this.debounceTimer);
//         this.debounceTimer = setTimeout(() => window.addLeisten(), 400);
//       }
//     });

//     document.addEventListener('click', (e) => {
//       const btn = e.target.closest('cart-remove-button, .delete-product');
//       if (btn) {
//         const item = btn.closest(CONFIG.CART_ITEM_SELECTOR);
//         const vid = item?.getAttribute('data-variant-id');
//         if (CONFIG.LEISTEN_VARIANTS.includes(String(vid))) {
//           MANUALLY_REMOVED_ITEMS.add(String(vid));
//         }
//       }
//     });

//     // const observer = new MutationObserver(() => {
//     //   if (!isProcessing && !isLocked) {
//     //     clearTimeout(this.debounceTimer);
//     //     this.debounceTimer = setTimeout(() => window.addLeisten(), 600);
//     //   }
//     // });

//     // const target = document.querySelector('cart-items') || document.body;
//     // observer.observe(target, { childList: true, subtree: true });

//     document.addEventListener('cart:updated', () => {
//       if (!isProcessing && !isLocked) {
//         clearTimeout(this.debounceTimer);
//         this.debounceTimer = setTimeout(() => window.addLeisten(), 600);
//       }
//     });

//     if (document.readyState === 'complete') {
//       setTimeout(() => window.addLeisten(), 500);
//     } else {
//       window.addEventListener('load', () => setTimeout(() => window.addLeisten(), 500));
//     }
//   }
// };

// CartEngine.init();

/**
 * leisten.js
 * Optimized Cart logic using reliable data attributes instead of HTML text scraping.
 *
 * CHANGELOG
 * - Fix: Parkett items (empty data-type) were not recognised as flooring, so the free
 *   Fußleisten were removed right after being added. Flooring detection is now shared
 *   (isFlooringType / isFlooringLi) and also accepts items with data-m2-per-package > 0.
 *   added a condition to fix the trittschalldaemmung products icorrectly being identifying as flooring product
 * - Fix: auto add/remove never triggered because the "cart:updated" event is not fired by the theme.
 *   addLeisten is now triggered by a fetch interceptor that watches /cart/add|change|update|clear
 *   (own calls are tagged with a header and ignored, so there is no feedback loop).
 * - Fix: quantities are read from the cart JSON (not the possibly stale DOM data-quantity);
 *   the DOM is only used for m2-per-package and flooring detection.
 * - Fix: calls arriving while processing/locked are queued and re-run instead of being dropped.
 * - Fix: DOM/API sync guard now retries (max 3x) instead of silently returning.
 * - Fix: failed cart writes (non-2xx) are now logged instead of failing silently.
 */

/* ============================================================
 * 1. CONFIG
 * ============================================================ */
const CONFIG = {
  LEISTEN_VARIANTS: [54219343888652, 54219671994636].map(String),
  CART_ITEM_SELECTOR: '.mini-cart__navigation > li',
  ENDPOINTS: { CHANGE: '/cart/change.js', ADD: '/cart/add.js', GET: '/cart.js' },
  FLOORING_KEYWORDS: ['boden', 'vinyl', 'laminat', 'parkett'],
  ACCESSORY_KEYWORDS: ['dammung', 'zubehor', 'kleber', 'eliminator', 'dampfbremse', 'folie'],
  EXCLUDED_TAGS: ['trittschalldämmung', 'trittschalldaemmung'],
  INTERNAL_HEADER: 'X-Leisten-Internal',
  CHECKOUT_SELECTORS: [
    '[name="checkout"]',
    '[href="/checkout"]',
    'a[href*="/checkout"]',
    '.cart__checkout-button',
    '.checkout-button',
    'button[data-checkout]',
    '#checkout',
  ].join(', ')
};

const MANUALLY_REMOVED_ITEMS = new Set();
let isProcessing = false;
let isLocked = false;
let rerunQueued = false;
let syncRetries = 0;

// Re-run addLeisten once the script is idle again (used when a call arrived while busy/locked).
const flushRerun = () => {
  if (rerunQueued && !isProcessing && !isLocked) {
    rerunQueued = false;
    setTimeout(() => window.addLeisten(), 300);
  }
};

/* ============================================================
 * HELPERS: SHARED FLOORING DETECTION
 * ============================================================ */
const isFlooringType = (t) => {
  const s = (t || '').toLowerCase();
  return CONFIG.FLOORING_KEYWORDS.some(k => s.includes(k));
};

const isAccessoryHandle = (h) => {
  const s = (h || '').toLowerCase();
  return CONFIG.ACCESSORY_KEYWORDS.some(k => s.includes(k));
};

const hasExcludedTag = (li) => {
  const tags = (li.getAttribute('data-tags') || '').toLowerCase().split('|');
  return CONFIG.EXCLUDED_TAGS.some(t => tags.includes(t));
};

// DOM-based check. Type match OR a positive m2-per-package (covers Parkett with empty data-type).
const isFlooringLi = (li) => {
  if (isAccessoryHandle(li.getAttribute('data-handle'))) return false;
  if (hasExcludedTag(li)) return false;   // tagged Trittschalldämmung → never flooring

  const type = (li.getAttribute('data-type') || '').toLowerCase();
  const m2 = parseFloat(li.getAttribute('data-m2-per-package')) || 0;
  const isCustomLook = li.getAttribute('data-custom-look') === 'true';
  const isSample = li.getAttribute('data-is-sample') === 'true';
  return (isFlooringType(type) || m2 > 0) && isCustomLook && !isSample;
};

/* ============================================================
 * HELPER: SECURE GENUINE FLOORING CHECK (ACCURATE TAG MATCHING)
 * ============================================================ */
const isGenuineFlooring = (item) => {
  // 1. Primary Check: DOM Data Attributes
  const domItem = document.querySelector(`${CONFIG.CART_ITEM_SELECTOR}[data-key="${item.key}"], ${CONFIG.CART_ITEM_SELECTOR}[data-variant-id="${item.variant_id}"]`);

  if (domItem) {
    // Explicitly block known accessories that might be wrongly categorized as flooring
    if (isAccessoryHandle(domItem.getAttribute('data-handle'))) {
      return false;
    }

    return isFlooringLi(domItem);
  }

  // 2. Strict Fallback Check
  const type = (item.product_type || '').toLowerCase();
  const title = (item.title || '').toLowerCase();

  if (isAccessoryHandle(item.handle)) {
    return false;
  }

  const matchesFlooring = isFlooringType(type);
  const isSampleFallback = type.includes('muster') || title.includes('muster');

  return matchesFlooring && !isSampleFallback;
};

/* ============================================================
 * 2. CART API
 * ============================================================ */
const CartAPI = {
  queue: Promise.resolve(),
  enqueue(fn) {
    this.queue = this.queue.then(fn).catch(err => console.error('CartAPI error:', err));
    return this.queue;
  },
  // Own writes carry a header so the fetch interceptor can ignore them.
  async write(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', [CONFIG.INTERNAL_HEADER]: '1' },
      body: JSON.stringify(body)
    });
    if (!res.ok) {
      let detail = '';
      try { detail = await res.clone().text(); } catch (_) {}
      console.error('[leisten] cart write failed', url, res.status, detail);
    }
    return res;
  },
  update(key, quantity) {
    return this.enqueue(() => this.write(CONFIG.ENDPOINTS.CHANGE, { id: key, quantity }));
  },
  add(id, quantity) {
    return this.enqueue(() => this.write(CONFIG.ENDPOINTS.ADD, { id, quantity }));
  },
  getCart: () => fetch(CONFIG.ENDPOINTS.GET).then(res => res.json())
};

/* ============================================================
 * 3. DOM HELPERS
 * Quantities come from the cart JSON when available (the DOM data-quantity can be stale
 * right after a change); the DOM supplies m2-per-package and the flooring check.
 * ============================================================ */
const DOM = {
  calculateBodenSum: (cart) => {
    const qtyByKey = cart ? new Map(cart.items.map(i => [i.key, i.quantity])) : null;
    const items = document.querySelectorAll(CONFIG.CART_ITEM_SELECTOR);

    return Array.from(items).reduce((sum, li) => {
      if (!isFlooringLi(li)) return sum;
      const m2PerPackage = parseFloat(li.getAttribute('data-m2-per-package')) || 0;
      const domQty = parseInt(li.getAttribute('data-quantity')) || 0;
      const quantity = qtyByKey?.get(li.getAttribute('data-key')) ?? domQty;
      return sum + (m2PerPackage * quantity);
    }, 0);
  },
  hasMainBodenProduct: (cart) => DOM.calculateBodenSum(cart) > 0
};

/* ============================================================
 * 4. CORE LOGIC
 * ============================================================ */
window.addLeisten = async function (manualVariantId = null) {
  if (isProcessing || isLocked) {
    rerunQueued = true;   // don't lose the change; run again when idle
    return;
  }
  isProcessing = true;

  try {
    const cart = await CartAPI.getCart();
    const bodenSum = DOM.calculateBodenSum(cart);
    const apiHasFlooring = cart.items.some(item => isGenuineFlooring(item));

    if (apiHasFlooring && bodenSum === 0) {
      // Sync Guard: API has flooring, but the drawer DOM isn't rendered/parsed yet.
      // Skip this run to prevent accidental removal, but retry a few times.
      if (syncRetries++ < 3) setTimeout(() => window.addLeisten(), 600);
      return;
    }
    syncRetries = 0;

    let targetQty = 0;
    if (apiHasFlooring && bodenSum >= 10) {
      targetQty = Math.round(bodenSum / 2.4);
    }

    const activeInCart = cart.items.filter(item => CONFIG.LEISTEN_VARIANTS.includes(String(item.variant_id)));
    let updated = false;

    if (!apiHasFlooring || (bodenSum > 0 && bodenSum < 10)) {
      for (const item of activeInCart) {
        await CartAPI.update(item.key, 0);
        updated = true;
      }
    }
    else if (targetQty > 0) {
      if (activeInCart.length > 0) {
        const primaryItem = activeInCart[0];
        if (primaryItem.quantity !== targetQty) {
          await CartAPI.update(primaryItem.key, targetQty);
          updated = true;
        }
      } else {
        const variantToAdd = manualVariantId
          ? (!MANUALLY_REMOVED_ITEMS.has(String(manualVariantId)) ? manualVariantId : null)
          : CONFIG.LEISTEN_VARIANTS.find(v => !MANUALLY_REMOVED_ITEMS.has(v));

        if (variantToAdd) {
          await CartAPI.add(variantToAdd, targetQty);
          updated = true;
        }
      }
    }

    if (updated) {
      isLocked = true;
      document.querySelector('cart-items')?.updateAllQuantities?.();
      setTimeout(() => { isLocked = false; flushRerun(); }, 1500);
    }

    // --- EVALUATE CHECKOUT FLAG ---
    let finalCart = cart;
    if (updated) {
      finalCart = await CartAPI.getCart();
    }
    CheckoutGate.updateButtonState(finalCart);

  } catch (e) {
    console.error("Script Error:", e);
  } finally {
    isProcessing = false;
    flushRerun();
  }
};

/* ============================================================
 * 5. CHECKOUT GATE (WITH FLAG LOGIC)
 * ============================================================ */
const CheckoutGate = {
  updateButtonState(cart) {
    const cartValue = cart.total_price || 0;
    const hasFreeProduct = cart.items.some(i => CONFIG.LEISTEN_VARIANTS.includes(String(i.variant_id)));
    const hasSampleProduct = cart.items.some(i => {
      const domItem = document.querySelector(`[data-key="${i.key}"], [data-variant-id="${i.variant_id}"]`);
      if (domItem) return domItem.getAttribute('data-is-sample') === 'true';
      const type = (i.product_type || '').toLowerCase();
      const title = (i.title || '').toLowerCase();
      return type.includes('muster') || title.includes('muster');
    });

    let flag = true;

    // RULE 1: Cart value is 0, contains sample AND free product => Disable
    if (cartValue === 0 && hasSampleProduct && hasFreeProduct) {
      flag = false;
    }

    // Apply the flag to all checkout buttons
    const checkoutBtns = document.querySelectorAll(CONFIG.CHECKOUT_SELECTORS);
    checkoutBtns.forEach(btn => {
      if (!flag) {
        btn.disabled = true;
        btn.style.opacity = '0.5';
        btn.style.pointerEvents = 'none';
        btn.title = 'Checkout gesperrt: Ungültige Gratisartikel im Warenkorb.';
      } else {
        if (btn._gateActive) return; // Preserve spinner state if currently processing
        btn.disabled = false;
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
        btn.title = '';
      }
    });
  },

  waitForIdle(maxMs = 5000) {
    return new Promise(resolve => {
      const start = Date.now();
      const tick = () => {
        if (!isProcessing && !isLocked) return resolve(true);
        if (Date.now() - start > maxMs) return resolve(false);
        setTimeout(tick, 80);
      };
      tick();
    });
  },

  async verifyCartSafe() {
    try {
      const cart = await CartAPI.getCart();
      const hasLeisten = cart.items.some(i => CONFIG.LEISTEN_VARIANTS.includes(String(i.variant_id)));
      const hasFlooring = cart.items.some(i => isGenuineFlooring(i));

      if (hasLeisten && !hasFlooring) return false;

      if (hasFlooring && hasLeisten) {
        const bodenSum = DOM.calculateBodenSum(cart);
        const domIsVisible = Array.from(document.querySelectorAll(`${CONFIG.CART_ITEM_SELECTOR}[data-custom-look="true"]`))
          .some(el => el.offsetHeight > 0 || el.offsetWidth > 0);
        if (domIsVisible && bodenSum > 0 && bodenSum < 10) return false;
      }

      return true;
    } catch {
      return false;
    }
  },

  showSpinner(btn) {
    if (!btn || btn._gateActive) return;
    btn._gateActive = true;
    btn._origHTML = btn.innerHTML;
    btn._origDisabled = btn.disabled;
    btn.disabled = true;
    btn.innerHTML = 'Warenkorb wird aktualisiert&hellip;';
    btn.style.opacity = '0.65';
    btn.style.cursor = 'wait';
  },

  hideSpinner(btn) {
    if (!btn) return;
    btn._gateActive = false;
    btn.disabled = btn._origDisabled || false;
    btn.innerHTML = btn._origHTML || btn.innerHTML;
    btn.style.opacity = '';
    btn.style.cursor = '';
  },

  showError(msg) {
    document.getElementById('_leisten-err')?.remove();
    const el = document.createElement('div');
    el.id = '_leisten-err';
    el.setAttribute('role', 'alert');
    Object.assign(el.style, {
      position: 'fixed', top: '16px', left: '50%',
      transform: 'translateX(-50%)', background: '#c0392b',
      color: '#fff', padding: '12px 22px', borderRadius: '6px',
      fontSize: '14px', zIndex: '999999',
      boxShadow: '0 4px 14px rgba(0,0,0,.3)',
      maxWidth: '88vw', textAlign: 'center', lineHeight: '1.4'
    });
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 4500);
  },

  _navigate(btn) {
    if (btn.tagName === 'A' && btn.href && !btn.href.endsWith('/cart')) {
      window.location.href = btn.href;
      return;
    }
    const form = btn.closest('form');
    if (form && form.action && form.action.includes('checkout')) {
      window.location.href = form.action;
      return;
    }
    window.location.href = '/checkout';
  },

  async onCheckoutEvent(e) {
    const btn = e.target.closest(CONFIG.CHECKOUT_SELECTORS);
    if (!btn || btn._gateActive || btn.disabled) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    CheckoutGate.showSpinner(btn);

    void window.addLeisten();

    const idled = await CheckoutGate.waitForIdle(5000);
    if (!idled) {
      CheckoutGate.hideSpinner(btn);
      CheckoutGate.showError('Warenkorb aktualisiert noch. Bitte versuchen Sie es gleich noch einmal.');
      return;
    }

    const safeNow = await CheckoutGate.verifyCartSafe();
    CheckoutGate.hideSpinner(btn);

    if (!safeNow) {
      CheckoutGate.showError('Ihr Warenkorb wurde korrigiert. Bitte gehen Sie erneut zur Kasse.');
      return;
    }

    CheckoutGate._navigate(btn);
  },

  attach() {
    CheckoutGate._boundClick = (e) => CheckoutGate.onCheckoutEvent(e);
    CheckoutGate._boundTouch = (e) => CheckoutGate.onCheckoutEvent(e);
    document.addEventListener('click',      CheckoutGate._boundClick, true);
    document.addEventListener('touchstart', CheckoutGate._boundTouch, { capture: true, passive: false });
    document.body.classList.add('cart-gate-ready');
  }
};

/* ============================================================
 * 6. ENGINE & OBSERVERS
 * ============================================================ */
const CartEngine = {
  debounceTimer: null,

  schedule(delay) {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => window.addLeisten(), delay);
  },

  // Watches every cart write made by the theme/apps (PLP add-to-cart, Quick View,
  // configurator, quantity changes, removals). Our own writes are tagged and ignored.
  patchFetch() {
    if (window.__leistenFetchPatched) return;
    window.__leistenFetchPatched = true;

    const originalFetch = window.fetch;
    const CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    const hasInternalHeader = (input, init) => {
      const h = init && init.headers;
      if (h instanceof Headers) return h.has(CONFIG.INTERNAL_HEADER);
      if (h && h[CONFIG.INTERNAL_HEADER]) return true;
      return input instanceof Request && input.headers.has(CONFIG.INTERNAL_HEADER);
    };

    window.fetch = async function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const isCartWrite = CART_WRITE.test(url);
      const isInternal = isCartWrite && hasInternalHeader(input, init);

      const res = await originalFetch.apply(this, arguments);

      if (isCartWrite && !isInternal && res.ok) {
        CartEngine.schedule(900);   // give the theme time to re-render the drawer
      }
      return res;
    };
  },

  init() {
    CheckoutGate.attach();
    this.patchFetch();

    document.addEventListener('change', (e) => {
      if (e.target.matches('.quantity__input')) {
        const item = e.target.closest(CONFIG.CART_ITEM_SELECTOR);
        const vid = item?.getAttribute('data-variant-id');

        if (CONFIG.LEISTEN_VARIANTS.includes(String(vid)) && parseInt(e.target.value) === 0) {
          MANUALLY_REMOVED_ITEMS.add(String(vid));
        }

        this.schedule(400);
      }
    });

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('cart-remove-button, .delete-product');
      if (btn) {
        const item = btn.closest(CONFIG.CART_ITEM_SELECTOR);
        const vid = item?.getAttribute('data-variant-id');
        if (CONFIG.LEISTEN_VARIANTS.includes(String(vid))) {
          MANUALLY_REMOVED_ITEMS.add(String(vid));
        }
      }
    });

    // Kept as an extra trigger in case the theme does dispatch this event.
    document.addEventListener('cart:updated', () => this.schedule(600));

    if (document.readyState === 'complete') {
      setTimeout(() => window.addLeisten(), 500);
    } else {
      window.addEventListener('load', () => setTimeout(() => window.addLeisten(), 500));
    }
  }
};

CartEngine.init();